<template>
  <el-form-item
    class="filter-field"
    v-if="isCorrectField && showField"
    :rules="rules"
    :prop="field.name"
  >
    <p v-if="field.type != 'bool'" class="filter-field__label">
      {{ field.label }}
    </p>
    <InputMasked
      v-if="field.type === 'phone'"
      :field="{
        name: field.name,
        placeholder: '',
        type: field.type
      }"
      :model="form[field.name] || ''"
      :mask="[
        '#',
        '##',
        '###',
        '####',
        '#####',
        '######',
        '#######',
        '########',
        '#########',
        '##########',
        '###########',
        '############',
        '#############',
        '##############',
        '###############'
      ]"
      @set-value="
        (name, val) => {
          setValue(field.name, val, field.type);
        }
      "
    />
    <div
      v-else-if="field.type === 'bool'"
      class="filter-field__items--switcher"
    >
      {{ field.label }}
      <Switcher
        :model="Boolean(form[field.name]) || false"
        @switch="
          val => {
            setValue(field.name, val);
          }
        "
      />
    </div>
    <Dropdown
      v-else-if="field.type === 'enum' || field.type === 'dynamicMultienum'"
      ref="dropdown"
      :model="form[field.name] || ''"
      :options="
        field.type === 'dynamicMultienum'
          ? paginOptions[field.name] || field.options
          : field.options
      "
      filterable
      :field="{
        disabled:
          field.name === 'hrpac_selection_stage_id_c_advanced' &&
          !form['hrpac_vacancy_id_c_advanced'],
        name: field.name,
        placeholder: '',
        multiple: field.type === 'dynamicMultienum',
        type: field.type === 'dynamicMultienum' ? 'relate' : 'enum'
      }"
      :arrow-multiselect-focus="true"
      @load-more="str => setNewOptions(str, field.name, field.paginationUrl)"
      @filter-option="
        str => filterOptions(str, field.name, field.paginationUrl)
      "
      :reserve-keyword="field.type === 'dynamicMultienum' ? true : false"
      :visible-option-btn="false"
      :visibleLoadMoreBtn="loadMoreNum == 50"
      create-btn-text="Добавить"
      popper-class="filter-dropdown"
      class="filter-form__filter"
      @set-value="
        (name, val) => {
          setValue(field.name, val);
        }
      "
    />
    <Dropdown
      v-else-if="field.type === 'multienum'"
      :model="form[field.name] || []"
      :field="{
        name: field.name,
        placeholder: '',
        type: 'multienum',
        multiple: true,
        filterable: true
      }"
      :options="field.options"
      popper-class="filter-dropdown"
      @set-value="
        (name, val) => {
          setValue(field.name, val);
        }
      "
    />
    <MultiLevelSelect
      v-else-if="field.type == 'multiLevelEnum'"
      :key="update"
      :field="field"
      :model="form[field.name] || ''"
      :label="multiLevelLabel"
      :options="paginOptions[field.name]"
      :module="module"
      @set-value="(name, val) => setValue(field.name, val, field.type)"
      @change-option="selectOption"
      @load-more="str => setNewOptions(str, field.name, field.paginationUrl)"
      @filter-option="
        str => filterOptions(str, field.name, field.paginationUrl)
      "
      @set-label="lbl => changeLabel(lbl)"
    />
    <MultiLevelSelectLazy
      v-else-if="field.type == 'multiLevelEnumLazy'"
      :key="update"
      :field="field"
      :model="form[field.name] || ''"
      :label="multiLevelLabel"
      :loading="loading"
      :options="paginOptions[field.name]"
      :visibleLoadMoreBtn="
        field['multi-level-schema']?.limit &&
        loadMoreNum == field['multi-level-schema']?.limit
      "
      :module="module"
      :form="form"
      :clearable="true"
      :lazy-loaded="lazyLoaded"
      @set-value="(name, val) => setValue(field.name, val, field.type)"
      @change-option="selectOption"
      @load-more="
        (str, method, url) => setNewOptions(str, field.name, url, true)
      "
      @filter-option="(str, method, url) => filterOptions(str, field.name, url)"
      @set-label="lbl => changeLabel(lbl)"
      @reset-lazy-loaded="lazyLoaded = false"
    />
    <DatePicker
      v-else-if="field.type === 'date' || field.type === 'datetime'"
      :model="form[field.name] || ''"
      :field="{
        name: field.name,
        type: 'date'
      }"
      :datepicker="datepicker"
      :options="pickerOptions"
      @set-value="(name, val) => setValue(field.name, val, 'else')"
    />
    <Input
      v-else
      :field="{
        htmlType: fieldType(field.type),
        name: field.name,
        maxlength: '255',
        type: field.type
      }"
      :model="formatHtml(form[field.name] || '')"
      @set-value="
        (name, val) => {
          setValue(field.name, val, 'else');
        }
      "
    />
  </el-form-item>
</template>

<script>
import { store } from '@/store';
import { getController } from '@/controllers/request.js';
import { setDateFormat } from '@/utils/helpers';
import { mixin } from '@/utils/mixins';
import Dropdown from 'Elements/Select/Dropdown';
import MultiLevelSelect from 'Elements/Select/MultiLevelSelect';
import Input from 'Elements/Input/Input';
import DatePicker from 'Elements/DatePicker/DatePicker';
import Switcher from 'Elements/Switch/Switch';
import InputMasked from 'Elements/Input/InputMasked';
import MultiLevelSelectLazy from 'Elements/Select/MultiLevelSelectLazy';
import { FormItem } from 'element-ui';
export default {
  mixins: [mixin],
  props: {
    field: Object,
    rules: Array,
    form: Object,
    showField: Boolean,
    loading: {
      type: Boolean
    },
    module: String
  },
  created() {
    if (!this.field.value && this.form[this.field.name])
      this.$set(this.field, 'value', this.form[this.field.name]);

    this.$set(this.datepicker, 'dateFormat', setDateFormat(this.dateFormat));
    if (
      (this.field.type == 'multiLevelEnum' ||
        this.field.type == 'multiLevelEnumLazy') &&
      this.field.value &&
      this.field.options?.length
    ) {
      this.$set(
        this.paginOptions,
        this.field.name,
        this.field.options.map(i => ({ ...i, name: this.formatHtml(i.name) }))
      );
      this.multiLevelLabel = this.formatHtml(this.field.options[0].name);
    }
  },
  mounted() {
    this.$emit('field-loaded');
    if (
      (this.field.type == 'multiLevelEnum' ||
        this.field.type == 'multiLevelEnumLazy') &&
      this.form[this.field.name] &&
      !this.paginOptions[this.field.name]?.length &&
      this.savedOptions.length
    ) {
      this.$set(this.paginOptions, this.field.name, this.savedOptions);
      this.multiLevelLabel = this.savedOptions[0].name;
      this.update++;
    }
  },
  data() {
    return {
      loadMoreNum: 0,
      datepicker: {
        dateFormat: '',
        timeFormat: 'HH:mm'
      },
      pickerOptions: {
        firstDayOfWeek: 1
      },
      paginOptions: {},
      fieldValue: {},
      multiLevelLabel: '',
      update: 0,
      lazyLoaded: false
    };
  },
  methods: {
    changeLabel(lbl) {
      this.multiLevelLabel = lbl;
    },
    fieldType(type) {
      switch (type) {
        case 'varchar':
        case 'text':
        case 'name':
          return 'text';

        case 'decimal':
        case 'int':
        case 'currency':
          return 'number';

        default:
          return '';
      }
    },
    filterOptions(search_string, fieldName, url) {
      this.fieldValue[fieldName] = [];

      if (this.form[fieldName] && this.form[fieldName].length) {
        for (let ind = 0; ind < this.form[fieldName].length; ind++) {
          if (
            this.paginOptions &&
            this.paginOptions[fieldName] &&
            this.paginOptions[fieldName].find(
              option =>
                option && option.id && option.id === this.form[fieldName][ind]
            )
          ) {
            this.fieldValue[fieldName].push(
              this.paginOptions[fieldName].find(
                option => option.id === this.form[fieldName][ind]
              )
            );
          } else if (
            this.field.type !== 'multiLevelEnum' &&
            this.field.type !== 'multiLevelEnumLazy' &&
            this.filters[fieldName] &&
            this.filters[fieldName]?.options &&
            Object.keys(this.filters[fieldName]?.options).length &&
            this.filters[fieldName]?.options[this.form[fieldName][ind]]
          ) {
            this.fieldValue[fieldName].push({
              id: this.form[fieldName][ind],
              name: this.filters[fieldName].options[this.form[fieldName][ind]]
            });
          }
        }
      }

      this.$set(this.paginOptions, fieldName, this.fieldValue[fieldName]);
      this.setNewOptions(search_string, fieldName, url);
    },
    async setNewOptions(
      search_string = '',
      fieldName,
      url,
      isLazyLoadMore = false
    ) {
      const iteration =
        this.paginOptions[fieldName].length <= 0
          ? 0
          : this.paginOptions[fieldName].length -
            this.fieldValue[fieldName].length;
      const params = {
        offset: iteration || 0,
        search_string: search_string.trim()
      };

      if (
        !url &&
        this.field.type == 'multiLevelEnumLazy' &&
        this.field['multi-level-schema']
      ) {
        const limit = this.field['multi-level-schema'].limit || '';
        url = this.field['multi-level-schema'].children + '&parent_id=';
        if (limit) url += `&limit=${limit}`;

        if (this.field.control_fields) {
          this.field.control_fields.forEach(name => {
            url += `&control_fields[${name}]=${
              this.form[name.split('__')[1]] || this.form[name] || ''
            }`;
          });
        }
      }
      const { data } = await getController({ url, params });
      if (!data) return;

      this.loadMoreNum = 0;
      this.checkOptions = [];
      let keyOptions = [];

      if (this.fieldValue[fieldName] && this.fieldValue[fieldName].length) {
        keyOptions = [...this.form[fieldName]];
      }

      if (
        Array.isArray(data) &&
        !data.length &&
        this.field.type == 'multiLevelEnum' /* ||
          this.field.type == 'multiLevelEnumLazy' */
      ) {
        this.$set(this.paginOptions, fieldName, []);
      } else {
        for (let key in data) {
          this.loadMoreNum++;

          if (typeof data[key] == 'object') {
            if (
              keyOptions.indexOf(data[key].id) == -1 &&
              this.paginOptions &&
              ((this.paginOptions[fieldName] &&
                !this.paginOptions[fieldName].find(
                  opt =>
                    opt &&
                    opt.id &&
                    opt.name &&
                    opt.id == data[key].id &&
                    opt.name == this.formatHtml(data[key].name)
                )) ||
                !this.paginOptions[fieldName].length)
            ) {
              const params = {
                ...data[key],
                id: data[key].id,
                name: this.formatHtml(data[key].name)
              };

              if (data[key].sub_text) {
                params.sub_text = this.formatHtml(data[key].sub_text);
              }

              this.checkOptions = [...this.checkOptions, params];
            }
          } else if (typeof data[key] == 'string') {
            const value = this.formatHtml(data[key]);
            if (
              keyOptions.indexOf(key) == -1 &&
              this.paginOptions &&
              ((this.paginOptions[fieldName] &&
                !this.paginOptions[fieldName].find(
                  opt =>
                    opt &&
                    opt.id &&
                    opt.name &&
                    opt.id == key &&
                    opt.name == value
                )) ||
                !this.paginOptions[fieldName].length)
            ) {
              this.checkOptions = [
                ...this.checkOptions,
                { id: key, name: value }
              ];
            }
          }
        }
      }

      this.$set(this.paginOptions, fieldName, [
        ...this.paginOptions[fieldName],
        ...this.checkOptions
      ]);

      store.commit('common/setNewOptions', {
        name: fieldName,
        val: this.paginOptions[fieldName]
      });

      if (
        (this.field.type == 'multiLevelEnum' ||
          this.field.type == 'multiLevelEnumLazy') &&
        this.paginOptions[fieldName].length
      ) {
        await this.formatTreeLabels(this.paginOptions[fieldName]);
      }
      if (isLazyLoadMore) this.lazyLoaded = true;

      return this.paginOptions[fieldName];
    },
    setValue(name, val, type = '') {
      this.$emit('set-value', name, val, type);
    },
    formatTreeLabels(data) {
      data.forEach(node => {
        if (node.name) {
          node.name = this.formatHtml(node.name);
        }
        if (node.children && node.children.length > 0) {
          this.formatTreeLabels(node.children);
        }
      });
    },
    selectOption(...params) {
      if (
        this.field.type == 'multiLevelEnum' ||
        this.field.type == 'multiLevelEnumLazy'
      ) {
        this.$emit(
          'change-option',
          ...params,
          'form',
          this.paginOptions[this.field.name]
        );
      } else {
        this.$emit('change-option', ...params);
      }
    }
  },
  computed: {
    isCorrectField() {
      return this.field && Object.keys(this.field).length;
    },
    filters() {
      return store.state.filters?.filterPopupMetaData?.panels
        ? store.state.filters?.filterPopupMetaData?.panels[0]?.rows
        : {};
    },
    savedOptions() {
      const filters = {
        ...store.state.filters.filterConfig.custom_filters,
        ...store.state.filters.filterConfig.filters
      };

      return filters[this.field.name]?.options
        ? filters[this.field.name].options
        : [];
    }
  },
  components: {
    Dropdown,
    MultiLevelSelect,
    Input,
    DatePicker,
    Switcher,
    InputMasked,
    MultiLevelSelectLazy,
    'el-form-item': FormItem
  }
};
</script>

<style lang="scss" scoped>
.filter-field {
  &__items {
    margin-top: 16px !important;

    &--switcher {
      flex-direction: row;
      width: 100%;
      font-size: 15px;
      line-height: 24px;
      color: $grey80;
      align-items: center;
      justify-content: space-between;
      display: flex;
    }
  }

  &__label {
    display: flex;
    font-size: 14px;
    line-height: 24px;
    color: #21272c;

    & + div {
      width: 100%;
    }
  }
}
</style>
